import React, { useEffect, useState } from 'react';

const PermissionLookupTable = (leftMenuItemValue, mySubscriptionPlan) => {
  //This is used to disable left menu buttons
  //Returns true when you have permission for an element .
  switch (leftMenuItemValue) {
    case 'typosquatting':
      return mySubscriptionPlan?.has_access_to_brand_impersonation_recipe
        ? true
        : false;
    case 'brand-impersonation':
      return mySubscriptionPlan?.has_access_to_brand_impersonation_recipe
        ? true
        : false;
    case 'forward-a':
      return mySubscriptionPlan?.has_access_to_ips_hosting_a_domain_recipe
        ? true
        : false;
    case 'ip-diversity':
      return mySubscriptionPlan?.has_access_to_ip_diversity_of_domain_recipe
        ? true
        : false;
    case 'reverse-a':
      return mySubscriptionPlan?.has_access_to_domains_hosted_on_ip_recipe
        ? true
        : false;
    case 'domain-on-server':
      return mySubscriptionPlan?.has_access_to_domains_hosted_on_server_recipe
        ? true
        : false;
    case 'ns-changes':
      return mySubscriptionPlan?.has_access_to_domain_name_server_changes_recipe
        ? true
        : false;
    case 'subdomain-finder':
      return mySubscriptionPlan?.has_access_to_subdomain_finder_recipe
        ? true
        : false;
    case 'shadow-it':
      return mySubscriptionPlan?.has_access_to_discover_shadow_it_recipe
        ? true
        : false;
    case 'hosting-infra-asns':
      return mySubscriptionPlan?.has_access_to_hosting_infra_asns_recipe
        ? true
        : false;
    case 'hosting-infra-ips':
      return mySubscriptionPlan?.has_access_to_hosting_infra_ips_recipe
        ? true
        : false;
    case 'latest-dns-records':
      return mySubscriptionPlan?.has_access_to_latest_dns_records_recipe
        ? true
        : false;
    case 'dangling-dns-records-count':
      return mySubscriptionPlan?.has_access_to_dangling_dns_records_count_recipe
        ? true
        : false;
    case 'dangling-dns-record':
      return mySubscriptionPlan?.has_access_to_dangling_dns_detection_recipe
        ? true
        : false;
    case 'domain-txt-records':
      return mySubscriptionPlan?.has_access_to_domain_txt_records_recipe
        ? true
        : false;
    case 'name-in-txt':
      return mySubscriptionPlan?.has_access_to_name_in_txt_recipe
        ? true
        : false;
    default:
      return false;
  }
};

export default PermissionLookupTable;
